<template>
  <div>
    <ticket-over-time-config v-if="!loading" :over-time-config="configData.ticket_daily_owner" :user-list="userData" />
    <ticket-ai-domain-config v-if="!loading" :over-time-config="configData.ticket_daily_owner" :user-list="userData" />
    <ticket-message-send-config v-if="!loading" :over-time-config="configData.ticket_over_time_value" :user-list="userData" />
    <a-row>
      <a-col class="gutter-row" :span="12">
        <ticket-tag-config />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <ticket-domain-config />
      </a-col>
    </a-row>
    <a-row>
      <a-col class="gutter-row" :span="12">
        <ticket-team-word :user-list="userData" />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <ticket-word />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getConfig } from '@/api/event/problem';
import { userList } from '@/api/system/auth';
import TicketOverTimeConfig from '@/pages/system/ticket/components/TicketOverTimeConfig';
import TicketAiDomainConfig from '@/pages/system/ticket/components/TicketAiDomainConfig';
import TicketTagConfig from '@/pages/system/ticket/components/TicketTagConfig';
import TicketDomainConfig from '@/pages/system/ticket/components/TicketDomainConfig';
import TicketWord from '@/pages/system/ticket/components/TicketWord';
import TicketTeamWord from '@/pages/system/ticket/components/TicketTeamWord';
import TicketMessageSendConfig from '@/pages/system/ticket/components/TicketMessageSendConfig';
export default {
  components: {
    TicketWord,
    TicketTeamWord,
    TicketTagConfig,
    TicketDomainConfig,
    TicketOverTimeConfig,
    TicketAiDomainConfig,
    TicketMessageSendConfig
  },
  data() {
    return {
      loading: true,
      userData: null,
      configData: {
        ticket_daily_owner: {}
      }
    };
  },
  computed: {},
  created() {
    this.getConfigList();
    this.getUserList();
  },
  methods: {
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users.filter(user => user.isDeleted !== 1 && user.fs_user_id !== '' && user.fs_user_id !== null);

        this.userData.push({
          fs_user_id: 'maintainer',
          nickname: '接手人'
        });
        this.userData.push({
          fs_user_id: 'handler',
          nickname: '处理人'
        });
      });
    },
    getConfigList() {
      this.loading = true;
      getConfig()
        .then(res => {
          this.configData = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.member-info {
  margin-left: 4px;
}
</style>
